import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import "../Header.css";
import SecondLogo from '../assets/secondlogo.png';
import "../Hero.css";

const Header = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    const toggleSidebar = () => setSidebarOpen((prev) => !prev);

    const navLinks = [
        { name: "Home", path: "/" },
        { name: "Services", path: "/services" },
        { name: "Career", path: "/career" },
        { name: "About Us", path: "/about" },
        { name: "Portfolio", path: "/portfolio" },
        { name: "FAQ", path: "/faq" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <header className="relative bg-black text-white w-full shadow-md z-50">
            <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-4">
                
                <div className="w-[240px] sm:w-[280px] md:w-[300px] pt-3 pb-2">
                    <img
                        src={SecondLogo}
                        alt="Lavanya Infotech Logo"
                        className="w-full object-contain"
                    />
                </div>

                {/* Desktop Nav */}
                <nav className="hidden md:flex space-x-6 font-medium text-lg">
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={`transition duration-200 hover:text-[#f19c79] ${location.pathname === link.path ? "text-[#f19c79] font-bold" : ""
                                }`}
                        >
                            {link.name}
                        </Link>
                    ))}
                </nav>

                {/* Mobile Menu Icon */}
                <button
                    onClick={toggleSidebar}
                    className="md:hidden focus:outline-none"
                    aria-label="Toggle menu"
                    aria-expanded={sidebarOpen}
                >
                    {sidebarOpen ? <FiX size={28} /> : <FiMenu size={28} />}
                </button>
            </div>

            {/* Mobile Sidebar */}
            <div
                className={`md:hidden absolute top-16 left-0 w-full bg-black border-t border-gray-700 transition-transform duration-300 ease-in-out ${sidebarOpen ? "transform translate-y-0 opacity-100" : "transform -translate-y-full opacity-0 pointer-events-none"
                    }`}
            >
                <nav className="flex flex-col items-center py-4 space-y-4">
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            onClick={() => setSidebarOpen(false)}
                            className={`text-lg transition hover:text-[#f19c79] ${location.pathname === link.path ? "text-[#f19c79] font-bold" : ""
                                }`}
                        >
                            {link.name}
                        </Link>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Header;
